import { useQualiopi } from '../../../../hooks/Settings';
import { BInputError, BRadio, BTextarea } from '../../../../components/ui/form';
import { requiredField } from '../../../../utils';

const Qualiopi = ({ categoryId, qualiopi, register, errors }) => {
  const { data, isSuccess } = useQualiopi(categoryId);
  if (!isSuccess) return;
  const isOther = data['Autre'] ? data['Autre'].some((qq) => qq.id + '' === qualiopi) : false;

  return (
    <div className={'flex flex-col gap-4'}>
      <div className="flex flex-col gap-4">
        <div>
          <p className={'text-lg leading-none font-semibold text-slate-700'}>Analyse du besoin</p>
          <BInputError errors={errors.qualiopi} />
        </div>
        {Object.keys(data).map((label, index) => (
          <div key={index} className={'flex flex-col gap-3'}>
            <p className={'text-sm font-medium text-slate-700'}>{label}</p>
            {data[label].map((question, index2) => (
              <div key={index2} className={'flex items-center gap-2'}>
                <BRadio
                  value={question.id}
                  label={question.question}
                  {...register('qualiopi', {
                    required: { value: true, message: 'Veuillez cocher une des cases ci dessous' },
                  })}
                  id={`Qualiopi${question.id}`}
                />
              </div>
            ))}
          </div>
        ))}
        <div>
          <BTextarea
            errors={errors.qualiopiDetails}
            isHidden={!isOther}
            rows={4}
            placeholder={'Précisez'}
            name={'qualiopiDetails'}
            {...register('qualiopiDetails', { required: { value: isOther, message: requiredField } })}
          />
        </div>
      </div>
    </div>
  );
};

export default Qualiopi;
